import { render, staticRenderFns } from "./per_cer.vue?vue&type=template&id=0f8d2e52&scoped=true&"
import script from "./per_cer.vue?vue&type=script&lang=js&"
export * from "./per_cer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d2e52",
  null
  
)

export default component.exports